module.exports = __webpack_public_path__ + "media/images/content-icon-sm-1-af44124bebf7cd2c45afaef584b2d40c.svg";